import React from 'react'
import { obtenerIdEmpresa, esSesionAdmin } from "../usuario/Usuario";
import {
  getTipoEventos
} from "../../components/correo/CorreoService";
import NavbarConfiguraciones from '../componentes/NavbarConfiguraciones';
import MensajeFlash from '../mensajeFlash/MensajeFlash';

class SeleccionPlantillas extends React.Component {

  constructor(props) {
    super(props);
    
    const { location } = this.props;
    const estado = location && location.state ? location.state : {};

    this.state = {
      idTipoEvento: null,
      tipoEventos: [],
      errorRecuperarInfo: false,
      mensajeFlash: estado.mensajeFlash || "",
      mostrarMensajeFlash: estado.mostrarMensajeFlash || false,
      mensajeFlashSeverity: estado.mensajeFlashSeverity || "neutral",
    };
  }

  componentDidMount = async () => {
    try {
      const empresa = esSesionAdmin() ? -200 : obtenerIdEmpresa();
      const response = await getTipoEventos(empresa);
      if (response && !response.error) {
        this.setState({ tipoEventos: response.datos });
      } else {
        this.setState({ mensajeFlash: response.mensaje, 
          mensajeFlashSeverity: "error", mostrarMensajeFlash: true});
      }
    } catch (error) {
      console.error("Error al recuperar tipos de evento:", error);
      this.setState({ mensajeFlash: "Error al recuperar tipos de evento",
         mensajeFlashSeverity: "error", mostrarMensajeFlash: true});
    }
  };

  handleRowClick = (plantilla) => {
    this.props.history.push({
      pathname: `/configuracion/plantilla-correo/editar`,
      state: { plantilla }
    });
  };

  render() {
    const { tipoEventos, errorRecuperarInfo } = this.state;

    return (
      <div>
        <div className="template-base">
          <NavbarConfiguraciones
            titulo={"Plantillas de correo"}
            descripcion={""}
            textoBoton={""}
            direccionBoton={"configuracion/tipo-documento/nuevo"}
          />

          <div className="wrapperContent">
            <div className="page-container">
              <div className="component-table">
                <div className="responsive-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Tipo de evento</th>
                      </tr>
                    </thead>
                    <tbody>
                      {errorRecuperarInfo ? (
                        <tr>
                          <td style={{ textAlign: "center", padding: "20px", color: "red" }}>
                            Error al recuperar los datos
                          </td>
                        </tr>
                      ) : tipoEventos.length > 0 ? (
                        tipoEventos.map((elemento) => (
                          <tr
                            key={elemento.id}
                            onClick={() => this.handleRowClick(elemento)}
                            style={{ cursor: "pointer" }}
                          >
                            <td>{elemento.nombre}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td style={{ textAlign: "center", padding: "20px" }}>
                            No se encontraron elementos
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <MensajeFlash
              visible={this.state.mostrarMensajeFlash}
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity} />
          </div>
        </div>
      </div>
    );
  }
}

export default SeleccionPlantillas;
